import { render, staticRenderFns } from "./VeJwTeachactList.vue?vue&type=template&id=64fbb6d6&scoped=true"
import script from "./VeJwTeachactList.vue?vue&type=script&lang=js"
export * from "./VeJwTeachactList.vue?vue&type=script&lang=js"
import style0 from "./VeJwTeachactList.vue?vue&type=style&index=0&id=64fbb6d6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64fbb6d6",
  null
  
)

export default component.exports